/**
 * ImportModal - Import Modal (CSV/XLSX) - extraído VERBATIM de ProductsContent.js (Fase 2 refactor).
 * Recebe estado/handlers via props do closure de ProductsContent.
 */
import React from 'react';
import { FileText, Upload } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const ImportModal = ({
  isImportModalOpen,
  setIsImportModalOpen,
  importFile,
  setImportFile,
  importResult,
  setImportResult,
  importing,
  handleImport,
  downloadTemplate,
}) => {
  return (
      <Dialog open={isImportModalOpen} onOpenChange={setIsImportModalOpen}>
        <DialogContent className="glass-modal max-w-lg">
          <DialogHeader>
            <DialogTitle className="text-white text-xl">Importar Cardápio</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Instructions */}
            <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4">
              <h3 className="text-sm font-semibold text-blue-400 mb-2">📋 Instruções:</h3>
              <ul className="text-xs text-gray-300 space-y-1">
                <li>• Baixe o template CSV para ver o formato</li>
                <li>• Preencha com seus dados (produtos, categorias, adicionais)</li>
                <li>• Faça upload do arquivo CSV ou XLSX preenchido</li>
              </ul>
            </div>

            {/* File Upload */}
            <div>
              <label className="block text-base font-medium text-gray-300 mb-2">
                Selecionar Arquivo CSV ou XLSX
              </label>
              <input
                type="file"
                accept=".csv,.xlsx"
                onChange={(e) => setImportFile(e.target.files[0])}
                className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700 rounded-xl text-white file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-500 file:text-white hover:file:bg-blue-600 cursor-pointer"
                data-testid="import-file-input"
              />
              {importFile && (
                <p className="text-sm text-green-400 mt-2">
                  ✓ Arquivo selecionado: {importFile.name}
                </p>
              )}
            </div>

            {/* Template Button */}
            <button
              onClick={downloadTemplate}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gray-800/50 border border-gray-700 rounded-xl text-gray-300 hover:bg-gray-800 hover:border-gray-600 transition-colors"
            >
              <FileText size={18} />
              <span>Baixar Template de Exemplo</span>
            </button>

            {/* Import Result */}
            {importResult && (
              <div className="space-y-3">
                <div className="bg-green-500/10 border border-green-500/20 rounded-xl p-4">
                  <h3 className="text-sm font-semibold text-green-400 mb-2">✓ Importação Concluída!</h3>
                  <ul className="text-xs text-gray-300 space-y-1">
                    <li>• {importResult.categories_created} categorias criadas</li>
                    <li>• {importResult.products_created} produtos criados</li>
                    <li>• {importResult.additionals_created} adicionais criados</li>
                    <li className="font-semibold text-green-400 mt-2">
                      Total: {importResult.total_created || 0} itens importados
                    </li>
                  </ul>
                </div>
                
                {importResult.warnings && importResult.warnings.length > 0 && (
                  <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4">
                    <p className="text-xs font-semibold text-yellow-400 mb-2">⚠️ Avisos ({importResult.warnings.length}):</p>
                    <div className="max-h-32 overflow-y-auto space-y-1">
                      {importResult.warnings.map((warn, i) => (
                        <p key={i} className="text-xs text-yellow-300">• {warn}</p>
                      ))}
                    </div>
                  </div>
                )}
                
                {importResult.errors && importResult.errors.length > 0 && (
                  <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-4">
                    <p className="text-xs font-semibold text-red-400 mb-2">❌ Erros ({importResult.errors.length}):</p>
                    <div className="max-h-32 overflow-y-auto space-y-1">
                      {importResult.errors.map((err, i) => (
                        <p key={i} className="text-xs text-red-300">• {err}</p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={() => {
                  setIsImportModalOpen(false);
                  setImportFile(null);
                  setImportResult(null);
                }}
                className="flex-1 px-4 py-3 text-base text-gray-400 hover:text-white transition-colors rounded-xl border border-gray-700 hover:border-gray-600"
                disabled={importing}
              >
                Cancelar
              </button>
              <button
                onClick={handleImport}
                disabled={!importFile || importing}
                className="flex-1 glass-button-primary py-3 px-6 text-base font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="import-upload-button"
              >
                {importing ? 'Importando...' : 'Importar'}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

  );
};

export default ImportModal;
